import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Subscription } from 'rxjs';
import {
  FileDownloadControlDto,
  FileDto,
} from 'src/app/data/models/dto/file.dto';
import { SnackbarTypeEnum } from 'src/app/data/models/enum/snackbar-type.enum';
import { FileService } from 'src/app/data/services/file.service';

import { CustomSnackbarService } from '../custom-snackbar/custom-snackbar-service';
import { FileUploadListComponent } from '../file-upload-list/file-upload-list.component';
import { FileUtils } from 'src/app/data/utils/file.utils';

@Component({
  selector: 'app-file-uploaded-list',
  templateUrl: './file-uploaded-list.component.html',
  styleUrls: ['./file-uploaded-list.component.scss'],
})
export class FileUploadedListComponent implements OnInit, OnChanges {
  @Input() initialFiles: string[] | FileDto[] = [];
  newStructure = true;
  oldStructureInitialFiles: string[] = [];
  newStructureInitialFiles: FileDto[] = [];

  @Input() type: string | undefined = 'attachment';
  @Input() filePathOldStructure: string = '';

  @Output() currentFilesEmitter = new EventEmitter<any[]>();
  @Output() filesToDeleteEmitter = new EventEmitter<any[]>();
  addedFiles: any[] = [];
  filesToDelete: any[] = [];

  downloadFilesControl: FileDownloadControlDto[] = [];
  files: File[] = [];
  textUploadButton: string = 'Adicionar imagem';
  attribAccpet: string = '*/*';
  imgURL: any[] = [];
  addItemText = 'Adicionar itens';

  uploadInProgress = false;
  showSelectFileDialog = true;
  subscribeDialog = new Subscription();

  constructor(
    private dialog: MatDialog,
    private fileService: FileService,
    private snackbarService: CustomSnackbarService,
    private fileUtils: FileUtils
  ) {}

  filesCountText = '';
  setFilesCountText() {
    this.addItemText = 'Adicionar mais itens';
    switch (this.downloadFilesControl.length) {
      case 0:
        this.filesCountText = 'Nenhum item anexado';
        this.addItemText = 'Adicionar itens';
        break;
      case 1:
        this.filesCountText = '1 item anexado';
        break;
      default:
        this.filesCountText = `${this.downloadFilesControl.length} itens anexados`;
        break;
    }
  }

  showInGrid = false;
  ngOnChanges(changes: SimpleChanges): void {
    this.newStructure =
      this.initialFiles.length == 0
        ? true
        : this.initialFiles[0] instanceof Object;
    this.showSelectFileDialog = !(
      this.type === 'background' && this.initialFiles.length > 0
    );
    this.initFileArrays();

    this.setFilesCountText();
    this.showInGrid = this.type === 'attachment';
  }

  ngOnInit(): void {
    this.attribAccpet = this.type === 'background' ? 'image/*' : '*/*';
  }

  private initFileArrays() {
    if (this.newStructure) this.initArraysNewStructure();
    else this.initArraysOldStructure();
    this.initialFiles.forEach(() => this.imgURL.push(null));
  }

  private initArraysNewStructure() {
    this.newStructureInitialFiles = this.initialFiles as FileDto[];
    this.downloadFilesControl = this.newStructureInitialFiles.map((file) => {
      return new FileDownloadControlDto(
        file.id,
        file.bucketKey,
        file.path,
        file.name,
        false
      );
    });
  }
  private initArraysOldStructure() {
    this.oldStructureInitialFiles = this.initialFiles as string[];
    this.downloadFilesControl = this.oldStructureInitialFiles.map((file) => {
      return new FileDownloadControlDto(
        '',
        '',
        this.filePathOldStructure,
        file,
        false
      );
    });
  }

  async onFilesSelected(event: any) {
    let filesToUpload: File[] = [];
    let e = event || window.event;
    for (var i = 0; i < e.target.files.length; i++) {
      let f = e.target.files[i];
      if (!this.validateFile(f) || this.sameNameFile(f.name)) {
        return;
      }
      filesToUpload.push(f);
      if (this.type === 'background') break;
    }
    if (filesToUpload.length == 0) return;
    this.openDialog(filesToUpload);
  }

  private openDialog(filesToUpload: File[]) {
    const dialogRef = this.dialog.open(FileUploadListComponent, {
      data: {
        files: filesToUpload,
        filePathOldStructure: this.filePathOldStructure,
      },
      disableClose: true,
      panelClass: 'custom-dialog-container',
      autoFocus: false,
    });
    this.subscribeDialog = dialogRef.componentInstance.onSuccess.subscribe(
      () => {
        this.updateArrays(
          filesToUpload,
          dialogRef.componentInstance.uploadedFiles
        );
        this.showSelectFileDialog = !(
          this.type === 'background' && this.downloadFilesControl.length > 0
        );

        if (this.newStructure) {
          this.currentFilesEmitter.emit(
            this.mapFileDownloadControl(this.downloadFilesControl)
          );
        } else {
          this.currentFilesEmitter.emit(
            this.downloadFilesControl.map((f) => f.name)
          );
        }
        this.setFilesCountText();
        dialogRef.close();
      }
    );
    this.subscribeDialog = dialogRef.componentInstance.onCancel.subscribe(
      () => {
        dialogRef.close();
      }
    );

    dialogRef.afterClosed().subscribe((result) => {
      this.subscribeDialog.unsubscribe();
    });
  }

  private updateArrays(files: File[], uploadedFilesInfo: FileDto[]) {
    if (this.type === 'background') {
      this.imgURL = [];
      this.downloadFilesControl = [];
      this.files = [];
    }
    files.forEach((f) => {
      var reader = new FileReader();
      reader.readAsDataURL(f);
      reader.onload = (_event) => {
        this.imgURL.push(reader.result);
      };
      this.files.push(f);
    });
    uploadedFilesInfo.forEach((upFile) => {
      this.downloadFilesControl.push(
        new FileDownloadControlDto(
          upFile.id,
          upFile.bucketKey,
          upFile.path,
          upFile.name,
          true,
          files.find((f) => f.name == upFile.name)
        )
      );
    });
  }

  private mapFileDownloadControl(files: FileDownloadControlDto[]): FileDto[] {
    let retFiles: FileDto[] = [];
    files.forEach((f) => {
      retFiles.push({
        id: f.id,
        bucketKey: f.bucketKey,
        path: f.path,
        name: f.name,
      } as FileDto);
    });
    return retFiles;
  }

  private validateFile(file: any) {
    const typePdf:boolean = file.type === 'application/pdf'
    if (
      file.type &&
      ((file.type.match(/^image\//) || typePdf) &&
      this.fileUtils.validateSize(file.size, typePdf)) 
    )
      return true;
    this.snackbarService.open(
      'O formato ou tamanho do arquivo não é suportado.',
      SnackbarTypeEnum.ERROR,
      'center',
      'bottom'
    );
    return false;
  }

  private sameNameFile(fileName: string) {
    if (this.downloadFilesControl.some((el) => el.name == fileName)) {
      this.snackbarService.open(
        'Arquivo com mesmo nome.',
        SnackbarTypeEnum.ERROR,
        'center',
        'bottom'
      );
      return true;
    }
    return false;
  }

  async onRemoveFileClick(fileName: string, it: number) {
    this.imgURL.splice(it, 1);
    for (let i = 0; i < this.files.length; i++) {
      if (this.files[i].name === fileName) {
        this.files.splice(i, 1);
        break;
      }
    }
    for (let i = 0; i < this.downloadFilesControl.length; i++) {
      if (this.downloadFilesControl[i].name === fileName) {
        if (this.isInitialFile(fileName))
          this.filesToDelete.push(this.downloadFilesControl[i]);
        else
          this.fileService.delete(this.downloadFilesControl[i].id).toPromise();
        this.downloadFilesControl.splice(i, 1);
        break;
      }
    }
    this.showSelectFileDialog = !(
      this.type === 'background' && this.downloadFilesControl.length > 0
    );
    this.setFilesCountText();
    if (this.newStructure) {
      this.currentFilesEmitter.emit(
        this.mapFileDownloadControl(this.downloadFilesControl)
      );
      this.filesToDeleteEmitter.emit(
        this.mapFileDownloadControl(this.filesToDelete)
      );
    } else {
      this.currentFilesEmitter.emit(
        this.downloadFilesControl.map((f) => f.name)
      );
      this.filesToDeleteEmitter.emit(this.filesToDelete.map((f) => f.name));
    }
  }

  private isInitialFile(fileName: string): boolean {
    if (this.newStructure) {
      return this.newStructureInitialFiles.some((f) => f.name == fileName);
    } else {
      return this.oldStructureInitialFiles.some((f) => f == fileName);
    }
  }
}
